exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2wwHUQEtxr-KUSA0FEdCY3{box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;list-style-type:none;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._2wwHUQEtxr-KUSA0FEdCY3 li{padding:10px;display:block}", ""]);

// exports
exports.locals = {
	"root": "_16mMvIGiMBe7oSm49TyRh7",
	"platformGrid": "_2wwHUQEtxr-KUSA0FEdCY3"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/postcss-loader!./components/media-platform-drawer.css
 ** module id = 1022
 ** module chunks = 0
 **/